// extracted by mini-css-extract-plugin
export default {"description":"Variants_description__2SELd","other":"Variants_other__lPowY"};